import React, { useState, useEffect, useContext, useRef } from 'react';
import { FormatAmount, FormatCreditCard } from '../../containers/common/functions';
import { AuthContext } from '../../context/AuthContext';
import AxioInstance from '../../axios/AxiosConfig';
import { useHistory } from 'react-router-dom';
import { ModalPassword } from '../modals/ModalPassword';
import ModalRecargaCard from '../../containers/layouts/ModalRecargaCard';

const TopUpCard = (props) => {
    const { card = {}, cardArrayProps = [] } = props.location.state;
    const [valueToTransfer, setValueToTransfer] = useState('');
    const [loadingTopUp, setLoadingTopUp] = useState(false);
    const [cardSelected, setCardSelected] = useState(card);
    const [cardArray, setCardArray] = useState([...cardArrayProps, card]);
    const [estimates, setEstimates] = useState(null);
    const [loadingEstimates, setLoadingEstimates] = useState(false);
    const { getAuthenticatedHeaders, userDetailsContext } = useContext(AuthContext)
    const [showModalPassword, setShowModalPassword] = useState(false);
    const [error, setError] = useState(null);
    const [errorTopUp, setErrorTopUp] = useState(null);
    const history = useHistory()
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successInfo, setSuccessInfo] = useState(null);
    const [trm, setTrm] = useState(0);

    // Referencia para el temporizador de debounce
    const timeoutRef = useRef(null);

    useEffect(() => {
        const fetchCards = async () => {
            try {
                const response = await AxioInstance.post('/api/get_card', {
                    headers: await getAuthenticatedHeaders(),
                });
                console.log("🚀 ~ fetchCards ~ response:", response)
                if (response.data?.status === 200) {
                    setCardArray(response.data?.data?.result); // Asumiendo que las tarjetas están en response.data.data
                } else {
                }
            } catch (e) {
            } finally {
            }
        };

        fetchCards();
    }, []);
    const handleTopUp = async () => {
        try {
            if (!cardSelected?.card_id) {
                alert('No hay tarjeta seleccionada.')
                return
            }

            setLoadingTopUp(true)
            const body = {
                amount: estimates?.USD,
                card_id: cardSelected?.card_id,
                headers: await getAuthenticatedHeaders(),
            }

            if (!estimates.USD) {

                setErrorTopUp('Error al hacer la recarga')
                return
            }

            const respTopUp = await AxioInstance.post('/api/create_and_reaload_card', body)

            if (respTopUp?.data?.status !== 200) {
                setErrorTopUp(respTopUp.data?.data?.message || 'Error inesperado')
                return
            }

            const { card } = respTopUp.data?.data
            const cardInfo = {
                creditCard: card.masked_pan,
                estimates,
                card
            }

            setSuccessInfo(cardInfo);
            setShowSuccessModal(true);



        } catch (error) {
            setErrorTopUp('Error al procesar la recarga')
        } finally {
            setLoadingTopUp(false)
        }
    }
    const CalculateCost = async () => {
        try {
            setLoadingEstimates(true)
            const respTrm = await AxioInstance.post('/api/estimates/card', {
                amount: null,
                is_created: null,
                headers: await getAuthenticatedHeaders(),

            })
            const trm = respTrm?.data?.data?.result?.amount_trm
            /*             console.log("🚀 ~ CalculateCost ~ respTrm:", trm)
             */
            const amountInCop = parseInt(valueToTransfer)

            const respEstimates = await AxioInstance.post('/api/estimates/card', {
                amount: amountInCop,
                is_created: false,
                headers: await getAuthenticatedHeaders(),

            })
            const estimates = respEstimates?.data?.data?.result
            if (estimates) {
                setEstimates(estimates)
            } else {
                setErrorTopUp('Error al calcular el costo')
            }
/*             console.log("🚀 ~ CalculateCost ~ estimates:", estimates)
 */        } catch (error) {
            setErrorTopUp('Error al calcular el costo')
        } finally {
            setLoadingEstimates(false)
        }
    }
    const checkUserPassword = async (password) => {
        handleTopUp()

    };

    useEffect(() => {
        getTrm()
    }, [])
    const getTrm = async () => {
        const respTrm = await AxioInstance.post('/api/price_trm', {
            headers: await getAuthenticatedHeaders(),
        })
        setTrm(respTrm?.data?.data?.price)
    }

    // Efecto para ejecutar CalculateCost cuando valueToTransfer cambie (con debounce)
    useEffect(() => {
        if (valueToTransfer) {
            // Limpia el temporizador anterior si existe
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // Establece un nuevo temporizador que ejecutará CalculateCost después de 800ms
            timeoutRef.current = setTimeout(() => {
                CalculateCost();
            }, 800);
        }

        // Limpia el temporizador cuando el componente se desmonte o valueToTransfer cambie
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [valueToTransfer]);

    return (
        <>
            {
                showModalPassword && (
                    <ModalPassword
                        handleOK={checkUserPassword}
                        handleCancel={() => {
                            setShowModalPassword(false)
                        }}
                        error={error}
                    />
                )
            }
            {showSuccessModal && (
                <ModalRecargaCard
                    info={successInfo}
                    setShowModal={setShowSuccessModal}
                    handleOk={() => {
                        setShowSuccessModal(false)
                        history.push('/tarjetas/detalle', {
                            ...cardSelected,
                            card_id: cardSelected?.card_id || cardSelected?.id
                        })
                    }}
                />
            )}

            <div className="flex flex-col min-h-screen justify-center items-center ">
                {/* Header */}
                {/*  <div className="sticky top-0 bg-white shadow-md p-4">
                <div className="flex items-center">
                    <button onClick={() => console.log("Go back")} className="mr-4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-8 w-8 text-gray-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 19l-7-7 7-7"
                            />
                        </svg>
                    </button>
                    <h1 className="text-lg font-bold">Recargar Tarjeta</h1>
                </div>
            </div> */}
                <div className="flex flex-col items-center py-4 shadow-md w-full">

                    <div className="text-center">
                        {/* <p className="text-sm text-gray-500">Disponible</p> */}
                        <p className="text-lg font-bold text-gray-800">
                            Recargar Tarjeta
                        </p>
                    </div>

                </div>
                {/* Main Content */}
                <div className="flex-1 p-4 max-w-sm w-full">
                    <h2 className="text-center font-semibold text-xl mb-6">Elige una Tarjeta</h2>

                    {/* Dropdown y Logo */}
                    <div className="flex items-center space-x-4 mb-6 relative">
                        <select
                            className="rounded py-3 px-4 w-full"
                            onChange={(e) => {
                                console.log("Card selected:", e.target)
                                setCardSelected(cardArray.find(card => card.card_id === e.target.value))

                            }}
                            /* onSelect={(e) =>
                                setCardSelected(cardArray.find(card => card.card_id === e.target.value))
                            } */
                            value={cardSelected?.card_id}
                        >
                            {cardArray.map((card, index) => (
                                <option key={index} value={card?.card_id}>{FormatCreditCard(card?.masked_pan, true)}</option>
                            ))}
                        </select>
                        <img
                            src={require('../../assets/card/VISA.png')}
                            alt="Visa"
                            style={{ right: '20px' }}
                            className="h-8 w-12 object-contain absolute"
                        />
                    </div>

                    {/* Input de Monto */}
                    <h2 className="text-center font-semibold text-xl mb-4">Monto a Recargar</h2>
                    <div className="bg-white shadow rounded py-3 px-4 flex items-center ">
                        <input
                            type="text"
                            value={FormatAmount(valueToTransfer, 1)}
                            onChange={(e) => {
                                const rawValue = e.target.value.replace(/\D/g, '');
                                setValueToTransfer(rawValue);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    CalculateCost();
                                }
                            }}
                            placeholder="Ingrese el monto"
                            className="flex-1 text-gray-800 border-none focus:outline-none"
                        />
                        {loadingEstimates && (
                            <div className="ml-2 flex-shrink-0">
                                <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-blue-500"></div>
                            </div>
                        )}
                    </div>
                    <p className="text-sm text-gray-500 ml-2 mb-4">
                        1 USD ~ {trm ? FormatAmount(Math.floor(trm) || "", 1) : 0}
                    </p>
                    {/* Monto Equivalente */}
                    {estimates && (
                        <>

                            <div className="mt-2 p-2 border rounded-md flex justify-between items-center">
                                <span className="text-gray-800">
                                    {estimates?.amount_dolar} USD
                                </span>
                                <img
                                    src={require('../../assets/card/USA.png')}
                                    alt="USA"
                                    className="h-8 w-8 object-contain"
                                />
                            </div>

                            {/* Resumen de Costos */}

                            <div className="bg-white shadow rounded-lg p-4 my-4">
                                <div className="flex justify-between mb-2">
                                    <span className="font-bold text-gray-800">Monto a Debitar</span>
                                    <span className="font-bold text-gray-800">
                                        {FormatAmount(parseInt(estimates?.debit_COP) || "", 1)}
                                    </span>
                                </div>
                                <div className="flex justify-between text-gray-600 mb-2">
                                    <span>Comisión de creación</span>
                                    <span>{FormatAmount(parseInt(estimates?.fee) || "", 1)}</span>
                                </div>
                                <div className="flex justify-between text-gray-600 mb-2">
                                    <span>IVA de Comisión</span>
                                    <span>{FormatAmount(parseInt(estimates?.vat) || "", 1)}</span>
                                </div>
                                <div className="flex justify-between font-bold text-gray-800">
                                    <span>Saldo en tarjeta</span>
                                    <span>{FormatAmount(estimates?.USD || "")} USD</span>
                                </div>
                            </div>
                        </>

                    )}
                    {errorTopUp &&
                        <span className="text-red-500 text-xs italic mb-4 flex justify-center">{errorTopUp}</span>
                    }

                    {/* Botón */}
                    <button

                        className={`w-full flex-shrink-0  text-sm text-white py-2 rounded-full  button-outline-off ${!estimates || loadingTopUp
                            ? 'bg-gray-400'
                            : 'bg-blue-600 hover:bg-blue-700'
                            }`}
                        onClick={handleTopUp}
                        disabled={!estimates || loadingTopUp}
                    >
                        {loadingTopUp ? 'Cargando...' : 'Recargar'}
                    </button>
                </div>
            </div>
        </>

    );
};

export default TopUpCard;
